module.exports = __webpack_public_path__ + "static/media/logo_af_pro.0692ae8c.svg";